import { Outlet, ScrollRestoration } from 'react-router-dom';
import '@/layouts/Default/stylesLayout';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import classes from './style.module.css';

const DefaultLayout = () => (
  <div className={classes.layout}>
    <ScrollRestoration />
    <Header />
    <main>
      <Outlet />
    </main>
    <Footer />
  </div>
);

export default DefaultLayout;
